
type UserAvatarProps = {
  name: string;         // user full name (for initials fallback)
  imageUrl?: string;    // optional avatar image url
  size?:"xs"| "sm" | "md" | "lg";
  className?: string;   // extra css classes if needed
};

const sizeMap = {
  xs:24,
  sm: 32,
  md: 48,
  lg: 72,
};

export function UserAvatar({
  name,
  imageUrl,
  size = "md",
  className = "",
}: UserAvatarProps) {
  const dimension = sizeMap[size] || sizeMap.md;

  // get initials from name (first letters of first two words)
  const getInitials = (fullName: string) => {
    const names = fullName.trim().split(" ");
    if (names.length === 0) return "";
    if (names.length === 1) return names[0][0].toUpperCase();
    return (names[0][0] + names[1][0]).toUpperCase();
  };

  return (
    <div
      className={`inline-flex items-center justify-center rounded-full bg-gray-300 text-gray-700 font-semibold select-none overflow-hidden ${className}`}
      style={{
        width: dimension,
        height: dimension,
        fontSize: dimension / 2,
      }}
      title={name}
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={name}
          className="object-cover w-full h-full"
          onError={(e) => {
            (e.currentTarget as HTMLImageElement).src = ""; // fallback blank
          }}
        />
      ) : (
        getInitials(name)
      )}
    </div>
  );
}
